import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearProjectActivityLogs } from "../../../actions/common";
import { label, number, quote } from "../../../config";
import { renderActivityLog } from "../../../helper/activityLogHelper";
import { seperateActivityLogsOnDate } from "../../../helper/common";
import { getProjectActivityLog } from "../../../shared/services/common.service";
import "./teamActivityLog.scss";

/**
 * TeamActivityLog component displays the activity log for a project with Load More button functionality.
 * @author Himanshu
 */
const TeamActivityLog = ({ projectId }) => {
  const [modifiedLogs, setModifiedLogs] = React.useState();
  const [loading, setLoading] = React.useState(false);

  const dispatch = useDispatch();
  const { projectLogs, isLastProjectActivityLog } = useSelector((state) => state.common);
  const { user } = useSelector((state) => state.auth);

  React.useEffect(() => {
    setModifiedLogs(seperateActivityLogsOnDate(projectLogs));
  }, [projectLogs]);

  React.useEffect(() => {
    (async () => {
      await dispatch(clearProjectActivityLogs());
      await getProjectActivityLog(parseInt(projectId), parseInt(user?.companyId), number?.FIFTEEN, number?.ZERO);
    })();
  }, [projectId]);

  /**
   * Handles Load More button click
   * Loads more activity logs when user clicks the button
   * @author Bhavana
   */
  const handleLoadMore = async () => {
    if (!isLastProjectActivityLog && !loading) {
      setLoading(true);
      await getProjectActivityLog(parseInt(projectId), parseInt(user?.companyId), number?.TWENTY, projectLogs?.length);
      setLoading(false);
    }
  };

  return (
    <>
      <div className='team-activity-log-container'>
        <div className='overflow-x-hidden'>
          <div>{modifiedLogs && renderActivityLog(modifiedLogs, true)}</div>
          {!isLastProjectActivityLog && (
            <div className='d-flex justify-content-center mt-3 mb-3'>
              <button
                type='button'
                className='btn btn-sm btn-ghost'
                onClick={handleLoadMore}
                disabled={loading}
                id='team-activity-log-load-more-btn'>
                {loading ? label.LOADING : quote.READ_MORE}
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TeamActivityLog;
